"use strict";
function mapMany(items, selector) {
    if (selector) {
        return Array.prototype.concat.apply([], items.map(selector));
    }
    else {
        return Array.prototype.concat.apply([], items);
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = mapMany;
//# sourceMappingURL=mapManyNative.js.map


// WEBPACK FOOTER //
// ./node_modules/arrayq/es6/mapManyNative.js